<template>
  <div class="header mb-3">
    <v-row class="px-1" style="align-items: center">
      <v-col cols="12" xs="5" sm="8">
        <div>
          <h1>RoomRounds</h1>
          <h3>Super Admin View</h3>
        </div>
      </v-col>
      <v-col cols="12" xs="7" sm="4" class="d-flex justify-end align-start">
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          transition="slide-y-transition"
          bottom
          :nudge-width="50"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <div
              class="d-flex align-center cursor-pointer"
              v-bind="attrs"
              v-on="on"
            >
              <!-- <v-avatar size="42">
                <img src="/img/user-image.png" />
              </v-avatar> -->
              <div class="mx-2 font-24" style="font-weight: 3400">
                Super Admin
              </div>
              <v-icon color="black" size="30">mdi-chevron-down</v-icon>
            </div>
          </template>

          <v-card>
            <v-list>
              <v-list-item>
                <!-- <v-list-item-avatar>
                  <img src="/img/user-image.png" alt="John" />
                </v-list-item-avatar> -->

                <v-list-item-content>
                  <v-list-item-title> Super Admin</v-list-item-title>
                  <v-list-item-subtitle>admin@gmail.com</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn block outlined @click="signOut()"> Sign Out </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-col>
    </v-row>
  </div>
</template>

<script>
//   import { mapGetters } from "vuex";
export default {
  name: "headercomponent",
  data() {
    return {
      fav: true,
      menu: false,
      message: false,
      hints: true,
      userdata: {},
      imageUrl: process.env.VUE_APP_IMG_API,
      userdata: "",
    };
  },
  // computed: {
  //   ...mapGetters(["getEmployeeById"]),
  // },
  mounted() {
    // this.fetchdata();
  },
  methods: {
    //   fetchdata() {
    //     const user_id = localStorage.getItem("user_id");
    //     if (user_id) {
    //       this.$store.dispatch("getEmployeeById", user_id).then(() => {
    //         this.userdata = this.getEmployeeById;
    //       });
    //     }
    //   },
    signOut() {
      localStorage.clear();
      sessionStorage.clear();
      this.$router.push("/");
    },
  },
};
</script>

<style></style>
